import useAuth from "../../hooks/useAuth";
import { Grid, Typography } from "@mui/material";
import React from "react";
import styled from "styled-components/macro";

const Footer = styled.div`
  background-color: ${(props) =>
    props.theme.palette.sidebar.footerBackground} !important;
  padding: ${(props) => props.theme.spacing(2.75)};
  ${(props) => props.theme.spacing(4)};
  border-right: 1px solid ${(props) => props.theme.palette.sidebar.border};
`;

const FooterText = styled(Typography)`
  color: ${(props) => props.theme.palette.sidebar.footerColor};
`;

const SidebarFooter = ({ ...rest }) => {
  const { user } = useAuth();

  return (
    <Footer {...rest}>
      <Grid container spacing={2}>
        <Grid item>
          {!!user && (
            <FooterText variant="body2">{user.displayName}</FooterText>
          )}
          {/* Demo data */}
          {!user && <FooterText variant="body2">Lucy Lavender</FooterText>}
        </Grid>
      </Grid>
    </Footer>
  );
};

export default SidebarFooter;
